import { findCurrentAgencies } from "../report/reportActions";

export const transformCoverageSummaryInput = (values) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);
  const transactionDates = [
    values.TransactionDate[0],
    values.TransactionDate[1],
  ];
  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    FileName: `CoverageSummary_${agency.Number}`,
    TransactionDate: transactionDates,
  };
};
